import {FunctionComponent, HTMLAttributes, useMemo} from 'react';
import {format, parseISO} from 'date-fns';
import {useDocumentLocale} from '@/components/document/hooks';
import {useDocumentStore} from '@/components/document/store';

type Props = HTMLAttributes<HTMLDivElement>;

const LastSave: FunctionComponent<Props> = () => {
  const {t} = useDocumentLocale();
  const updatedAt = useDocumentStore(state => state.meta.updatedAt);

  const formattedUpdatedAt = useMemo(() => {
    return updatedAt
      ? format(parseISO(updatedAt), 'yyyy-MM-dd HH:mm')
      : t('components.sections-selector.last-save.never-saved');
  }, [t, updatedAt]);

  return (
    <div className="mb-4 pt-6 text-center text-xs">
      <span className="mr-1 text-grey">{t('components.sections-selector.last-save.label')}</span>
      <span data-testid="document-last-save" className="text-charcoal">
        {formattedUpdatedAt}
      </span>
    </div>
  );
};

export default LastSave;
